/* Goodest foundation — minimal motion runtime.
   - Reveals [data-reveal] elements on scroll using IntersectionObserver.
   - Auto-tags [data-reveal-delay] on direct children with class
     "gd-reveal-stagger" so sections don't have to hand-author indices.
   - Honors prefers-reduced-motion (CSS already short-circuits but we
     also avoid setting up the observer at all so we don't waste cycles).
   No frameworks, no libraries, ~60 lines. */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Also observe the legacy .gv2-reveal class used by existing
  // homepage sections (before-after, how-it-works, style-preview, etc.).
  var revealSelector = '[data-reveal], .gv2-reveal';

  if (prefersReducedMotion) {
    document.querySelectorAll(revealSelector).forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var atmosphereSelector = '.goodest-atmosphere';
  var scrollRaf = 0;

  function setAtmosphereScroll() {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = 0;
      document.querySelectorAll(atmosphereSelector).forEach(function (section) {
        var rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        var shift = (Math.max(0, Math.min(1, progress)) - 0.5) * 18;
        section.style.setProperty('--gd-scroll-shift', shift.toFixed(1) + 'px');
      });
    });
  }

  window.addEventListener('scroll', setAtmosphereScroll, { passive: true });
  window.addEventListener('resize', setAtmosphereScroll, { passive: true });
  setAtmosphereScroll();

  // Stagger helper — applies sequential [data-reveal-delay] to children
  // of any element marked .gd-reveal-stagger, so a section grid can opt
  // in without templates having to number every block.
  document.querySelectorAll('.gd-reveal-stagger').forEach(function (parent) {
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', '');
      if (!child.hasAttribute('data-reveal-delay')) {
        child.setAttribute('data-reveal-delay', String(Math.min(i + 1, 6)));
      }
    }
  });

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(revealSelector).forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.05
  });

  function observeAll() {
    document.querySelectorAll(revealSelector).forEach(function (el) {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Section editor in Shopify re-injects nodes; observe new ones.
  document.addEventListener('shopify:section:load', observeAll);
})();
